import { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import { AttorneyService } from "../../../../services/ClientService";

import { useCallback } from "react";

export default function Service({
    attorney,
}: {
    attorney: APIModels.Attorney;
}): JSX.Element {
    const [updatedAttorney, setUpdatedAttorney] = useState(attorney);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setUpdatedAttorney(attorney);
    }, [attorney]);

    const onSaveClick = useCallback(async () => {
        setSaving(true);
        AttorneyService.saveService({
            attorneyId: attorney.id!,
            body: updatedAttorney,
        }).then(
            (resp) => {
                setSaving(false);
                if (resp.successful === true) {
                    setErrorMessage(resp.errorMessage ?? "");
                    attorney = { ...resp.data };
                } else {
                    // eslint-disable-next-line no-console
                    console.log(resp.errorMessage);
                }
            },
            (error) => {
                setSaving(false);
                // disable lint warning for now
                // eslint-disable-next-line no-console
                console.log(error);
                setErrorMessage("An error has occurred");
            }
        );
    }, [updatedAttorney]);

    return (
        <div className="card text-left">
            <div className="card-body">
                <h4 className="mb-3 bg-light p-2">Attorney Service</h4>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtAssistantEmails"
                            className="form-label"
                        >
                            Assistant Emails
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtAssistantEmails"
                                placeholder="Assistant"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.assistantEmails}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        assistantEmails:
                                            event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid first name.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtServiceEmails"
                            className="form-label"
                        >
                            Service Emails
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtServiceEmails"
                                placeholder="Service"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.serviceEmails}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        serviceEmails:
                                            event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid middle name.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtBlackListEmails"
                            className="form-label"
                        >
                            BlackList Emails
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtBlackListEmails"
                                placeholder="Blacklist"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.blacklistEmails}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        blacklistEmails:
                                            event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid middle name.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-sm-4">
                        <label htmlFor="txtBCCEmails" className="form-label">
                            BCC Emails
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtBCCEmails"
                                placeholder="BCC"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.bccEmails}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        bccEmails: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid middle name.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="txtReplyEmail" className="form-label">
                            Reply Email
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtReplyEmail"
                                placeholder="Reply"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.replyEmail}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        replyEmail: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid state.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <label htmlFor="txtSignature" className="form-label">
                            Signature
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtSignature"
                                placeholder="Signature"
                                aria-describedby="inputGroupPrepend"
                                value={updatedAttorney.signature}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        signature: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid signature.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtUseDocumentEmails"
                                placeholder="UseDoucmentEmails"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={
                                    updatedAttorney.useDocumentEmails ?? false
                                }
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        useDocumentEmails:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtUseDocumentEmails"
                                className="form-check-label"
                            >
                                Use Document Emails
                            </label>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtUsePortalEmails"
                                placeholder="UsePortalEmails"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={
                                    updatedAttorney.usePortalEmails ?? false
                                }
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        usePortalEmails:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtUsePortalEmails"
                                className="form-check-label"
                            >
                                Use Portal Emails
                            </label>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtServeThroughPortal"
                                placeholder="ServeThroughPortal"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={
                                    updatedAttorney.serveThroughPortal ?? false
                                }
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        serveThroughPortal:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtServeThroughPortal"
                                className="form-check-label"
                            >
                                Serve Through Portal
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtNoService"
                                placeholder="NoService"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={updatedAttorney.noService ?? false}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        noService: event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtNoService"
                                className="form-check-label"
                            >
                                No Service
                            </label>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtNoPortalService"
                                placeholder="NoPortalService"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={
                                    updatedAttorney.noPortalService ?? false
                                }
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        noPortalService:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtNoPortalService"
                                className="form-check-label"
                            >
                                No Portal Service
                            </label>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtCleanFilename"
                                placeholder="CleanFileName"
                                aria-describedby="inputGroupPrepend"
                                type="checkbox"
                                checked={updatedAttorney.cleanFilename ?? false}
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        cleanFilename:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtCleanFilename"
                                className="form-check-label"
                            >
                                Clean Filename
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    {" "}
                    <div className="col-sm-4">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtStampPDF"
                                placeholder="StampPDF"
                                aria-describedby="inputGroupPrepend"
                                checked={updatedAttorney.stampPDF ?? false}
                                type="checkbox"
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        stampPDF: event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtStampPDF"
                                className="form-check-label"
                            >
                                Stamp PDF
                            </label>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="txtMatterNumberFilename"
                                placeholder="Matter Number Filename"
                                aria-describedby="inputGroupPrepend"
                                checked={
                                    updatedAttorney.controlNumberInFilename ??
                                    false
                                }
                                type="checkbox"
                                onChange={(event) =>
                                    setUpdatedAttorney({
                                        ...updatedAttorney,
                                        controlNumberInFilename:
                                            event.currentTarget.checked,
                                    })
                                }
                            />
                            <label
                                htmlFor="txtMatterNumberFilename"
                                className="form-check-label"
                            >
                                Matter Number Filename
                            </label>
                        </div>
                    </div>
                </div>
                <div className="text-end">
                    {saving ? (
                        <button
                            className="btn btn-success waves-effect waves-light mt-2"
                            type="button"
                            disabled={true}
                        >
                            <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Saving...
                        </button>
                    ) : (
                        <button
                            className="btn btn-success waves-effect waves-light mt-2"
                            type="submit"
                            onClick={onSaveClick}
                        >
                            <i className="mdi mdi-content-save me-1"></i>
                            Save
                        </button>
                    )}
                    <div>{errorMessage}</div>
                </div>
            </div>
        </div>
    );
}
